export const adminNavigation = [
    {
        key: 'management',
        title: '管理',
        icon: 'appstore',
        description: '渠道方、运营方、服务套餐、司机审核',
        children: [
            {
                key: 'channels',
                routeName: 'Channels',
                view: 'Channels',
                title: '渠道方',
                shortTitle: '渠道方',
                path: '/management/channels',
                icon: 'share-alt',
                description: '管理渠道方名称、类别、区域、分成、链接和二维码。',
            },
            {
                key: 'operators',
                routeName: 'Operators',
                view: 'Operators',
                title: '运营方',
                shortTitle: '运营方',
                path: '/management/operators',
                icon: 'team',
                description: '管理运营方名称、区域、简介和联系电话。',
            },
            {
                key: 'servicePackages',
                routeName: 'ServicePackages',
                view: 'ServicePackages',
                title: '服务套餐',
                shortTitle: '服务套餐',
                path: '/management/packages',
                icon: 'tags',
                description: '管理护送服务与搬抬服务相关套餐。',
            },
            {
                key: 'driverAudits',
                routeName: 'DriverAudits',
                view: 'DriverAudits',
                title: '司机审核',
                shortTitle: '司机审核',
                path: '/management/driver-audits',
                icon: 'audit',
                description: '审核司机资料、车辆信息和审核状态。',
            },
        ],
    },
    {
        key: 'orders',
        title: '订单',
        icon: 'profile',
        description: '订单列表与订单资料维护',
        children: [
            {
                key: 'ordersList',
                routeName: 'Orders',
                view: 'Orders',
                title: '订单列表',
                shortTitle: '订单列表',
                path: '/Orders',
                icon: 'unordered-list',
                description: '管理患者、联系人、地址、服务信息和订单状态。',
            },
        ],
    },
    {
        key: 'accounts',
        title: '账号',
        icon: 'safety',
        description: '角色与账号',
        children: [
            {
                key: 'roles',
                routeName: 'Roles',
                view: 'Roles',
                title: '角色',
                shortTitle: '角色',
                path: '/accounts/roles',
                icon: 'safety',
                description: '维护后台角色、权限说明和状态。',
            },
            {
                key: 'permissions',
                routeName: 'Permissions',
                view: 'Permissions',
                title: '权限管理',
                shortTitle: '权限管理',
                path: '/accounts/permissions',
                icon: 'control',
                description: '维护菜单权限、路由配置和操作按钮。',
            },
            {
                key: 'accountsList',
                routeName: 'Accounts',
                view: 'Accounts',
                title: '账号',
                shortTitle: '账号',
                path: '/accounts/list',
                icon: 'user',
                description: '维护后台账号、手机号、角色和状态。',
            },
        ],
    },
]

export function flattenNavigation (tree = adminNavigation) {
    const leaves = []

    tree.forEach(section => {
        section.children.forEach(item => {
            leaves.push({
                ...item,
                sectionKey: section.key,
                sectionTitle: section.title,
                sectionIcon: section.icon,
                sectionDescription: section.description,
                titlePath: [section.title, item.title],
            })
        })
    })

    return leaves
}

export const adminLeaves = flattenNavigation()

export const defaultAdminPath = adminLeaves[0].path

export const legacyRedirects = {
    '/dashboard': defaultAdminPath,
    '/analytics': defaultAdminPath,
    '/products': '/management/packages',
    '/users': '/accounts/roles',
    '/content': '/accounts/list',
    '/settings': '/accounts/roles',
    '/logs': '/accounts/list',
    '/orders': '/Orders',
    '/orders/list': '/Orders',
}

export function findLeafByPath (path) {
    return adminLeaves.find(item => item.path === path) || adminLeaves[0]
}
